import { Component, Injector, OnDestroy } from '@angular/core';
import { TooltipIconConfig } from '@app/shared/types';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { cloneDeep, forEach, get, isFunction } from 'lodash';
import { Subscription, isObservable, of } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { observableCombineLatest } from '@shared/rx';
import { asObservable } from '@app/shared/utils';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-icons-renderer',
  templateUrl: './icons-renderer.component.html',
  styleUrls: ['./icons-renderer.component.scss'],
})
export class IconsRendererComponent implements AgRendererComponent, OnDestroy {
  public value: TooltipIconConfig[] = [];
  public isBusy: boolean = false;
  public subscriptions: Subscription[] = [];
  public test: boolean = true;

  public constructor(public injector: Injector) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public refresh(params: any): boolean {
    return false;
  }

  public agInit(params: ICellRendererParams): void {
    const { isBusy, dataSource, filterFn, valueMapper } = get(
      params,
      ['colDef', 'cellRendererParams'],
      {} as any,
    );
    const { data: rowData, value: cellValue } = params;
    const isBusy$ = asObservable<boolean>(isBusy);
    const dataSource$ = isObservable(dataSource) ? dataSource : of(dataSource);
    this.subscriptions.push(
      observableCombineLatest([isBusy$, dataSource$])
        .pipe(distinctUntilChanged())
        .subscribe(([busyStatus, data]) => {
          this.isBusy = busyStatus;
          let filteredData = data;

          if (busyStatus) return;

          if (isFunction(filterFn)) {
            filteredData = filterFn(filteredData, rowData);
          }

          this.value = isFunction(valueMapper)
            ? valueMapper({
                rowData,
                cellValue,
                params,
                sourceResult: filteredData,
                oldValue: cloneDeep(this.value),
              })
            : filteredData;
        }),
    );
  }

  public ngOnDestroy(): void {
    forEach(this.subscriptions, (subscribe) => subscribe.unsubscribe());
    this.subscriptions = [];
  }
}
